import React, { useEffect } from 'react';
import { View } from 'react-native';
import Animated, {
  useAnimatedStyle,
  useReducedMotion,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';
import { useTranslation } from 'react-i18next';

import { AppText } from './AppText';

/** The teal pulsing LIVE chip - the only place the live accent breathes. */
export function LiveBadge({ minute }: { minute?: number | null }) {
  const { t } = useTranslation();
  const reducedMotion = useReducedMotion();
  const pulse = useSharedValue(1);

  useEffect(() => {
    if (!reducedMotion) {
      pulse.value = withRepeat(withTiming(0.35, { duration: 900 }), -1, true);
    }
  }, [pulse, reducedMotion]);

  const dotStyle = useAnimatedStyle(() => ({ opacity: pulse.value }));

  return (
    <View className="flex-row items-center gap-1.5 rounded-full bg-live/10 px-2.5 py-1">
      <Animated.View style={dotStyle}>
        <View className="h-1.5 w-1.5 rounded-full bg-live" />
      </Animated.View>
      <AppText variant="micro" weight="bold" tabular className="text-live">
        {typeof minute === 'number' ? `${minute}′` : t('common.live')}
      </AppText>
    </View>
  );
}
